module.exports = __webpack_public_path__ + "static/media/clear-night.b30c2141.jpeg";